/* eslint-disable no-undef */

// Módulos externos que requieren inicialización y hacks varios para
// que todo funcione en webpack y browserify, especialmente módulos
// que no están pensados bien para CommonJS

import 'whatwg-fetch'; // Polyfill de fetch para safari
import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import 'bootstrap';
import 'bootstrap-datepicker';
import 'jquery-slimscroll';
import 'select2';

import '../core/lib/vendor/homer.js';
import './app/main.tsx';
